import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import TcEventService from './TcEventService';
import { connect } from 'react-redux';
import { withRouterLegacy } from 'core/routerUtils';
import * as tcEventActions from 'features/tc-event-dashboard/duck';
import * as staffActions from 'features/staff-and-rooms/duck';
import * as irregularitiesActions from 'features/irregularities/duck';
import * as eventChecklistActions from 'features/event-checklist/duck';
import * as materialChainActions from 'features/material-chain/duck';
import * as requestUpdateActions from 'features/request-update/duck';
import * as staticActions from 'shared/ducks/staticDuck';
import moment from 'moment';
import { withTranslation } from 'react-i18next';
import { get, isEmpty } from 'lodash';
import {
  TcEventCapacity,
  TcEventChecklist,
  TcEventStaffAndRooms,
  TcEventIrregularities,
  TcEventMaterials,
  TcEventShipping,
  TcEventRoster,
  TcEventCheckout,
} from 'features/tc-event-dashboard';
import { RequestUpdateContainer } from 'features/request-update';
import { Accordion, Spinner, EventDashboardDetails, AlertMessage } from 'shared/components';
import { PermissionsService } from 'shared/services';
import {
  CATEGORY_PRE_TEST,
  CATEGORY_POST_TEST,
  REQUEST_UPDATE_STATUS,
  ONLINE_PROVIDERS,
} from 'shared/constants';
import { getEventTasksCompleted } from 'features/event-checklist/selectors';
import { checkForOnlineRooms } from 'shared/helpers';
import {
  mapRoomsByLocation,
  hasEventPaperCapacity,
  getManualTimerFlags,
  hasEventOnlineCapacity,
} from 'features/tc-event-dashboard/selectors';
import {
  mapRoomMaterials,
  mapEventMaterialTypes,
  mapEventMaterials,
  calculateEventUsedMaterials,
} from 'features/material-chain/selectors';
import { getSubmittedIrregularities } from 'features/irregularities/selectors';
import { setEventStaffCounts } from 'features/staff-and-rooms/selectors';
import PendingIcon from 'assets/svgs/pendingIcon.svg';
import LaunchIcon from 'assets/svgs/launch.svg';

import './TcEventDashboard.scss';

const getTotal = (locations) => {
  let total = 0;
  if (locations?.length) {
    locations.forEach((location) => {
      total = location.rooms ? location.rooms.length + total : total;
    });
  }
  return total;
};

const isTouchScreen =
  'ontouchstart' in globalThis || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;

const isCurrentOrPastEventDate = (serverDateTime, eventDate) => {
  const currentDate = moment(serverDateTime);

  return currentDate.isSameOrAfter(moment(eventDate));
};

class TcEventDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      tasks: [],
      delegateDutiesOpen: false,
      assignStaffOpen: false,
      removeCoordinator: false,
      showMessage: false,
      isErrorAlertMessage: false,
      toastMessage: '',
    };

    this.openRequestUpdateTab = this.openRequestUpdateTab.bind(this);
  }

  componentDidMount() {
    const { actions } = this.props;

    actions.getTcEvent(this.props.match.params.eventId).then(() => {
      const { tcEvent } = this.props;

      if (!isEmpty(tcEvent)) {
        actions.getTestCenterCycle(tcEvent.id).then(() => {
          if (
            (PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
              PermissionsService.hasEventManage(tcEvent.id)) &&
            this.props.testCenterCycle?.testCenterProgram?.testCenter?.id
          ) {
            actions.getRequestUpdate(
              this.props.testCenterCycle?.testCenterProgram?.testCenter?.id,
              tcEvent.testingEvent.id
            );
          }
        });
        actions.getRooms(tcEvent.id);
        actions.clearTcEventStaffAction();
        actions.clearTcEventNonPersonnelStaffAction();
        actions.getTcEventStaff(tcEvent.id);
        actions.getTcEventNonPersonnelStaff(tcEvent.id);
        actions.getRoomsDTO(tcEvent.id);
        actions.getTCEventMaterialTypes(tcEvent.id);
        actions.getEventAllMaterials(tcEvent.id);
        actions.getRoomMaterialsCount(tcEvent.id);
        actions.getCapacityTypes(tcEvent.testingEvent.adminId.cycleId.id);
        if (
          PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
          PermissionsService.hasEventManage(tcEvent.id)
        ) {
          actions.getEventTasks(tcEvent.id, { category: CATEGORY_PRE_TEST });
          actions.getEventTasks(tcEvent.id, { category: CATEGORY_POST_TEST });
        }
        actions.getDevicesCheckCount(tcEvent.id);
      }
    });
    actions.getServerDateTime();
    actions.getTcEventIrregularities(this.props.match.params.eventId);
  }

  componentDidUpdate() {
    Array.from(document.querySelectorAll('[data-bs-toggle="popover"]')).forEach((el) =>
      bootstrap.Popover.getOrCreateInstance(el).enable()
    );
    Array.from(document.querySelectorAll('.request-update-edit-btn')).forEach((el) => {
      const popover = bootstrap.Popover.getOrCreateInstance(el);
      if (isTouchScreen) {
        popover.disable();
      } else {
        popover.enable();
      }
    });
  }

  componentWillUnmount() {
    this.props.actions.getRoomTypesAction({ data: [] });
  }

  openRequestUpdateTab(tabName) {
    this.child.openRequestUpdateTab(tabName);
  }

  removeMessage() {
    this.setState({
      showMessage: false,
    });
  }

  async copyHandle() {
    await TcEventService.getUnityDownloadLink(this.props.tcEvent?.id)
      .then((result) => {
        if (result) {
          navigator.clipboard.writeText(result);
          this.setState({
            showMessage: true,
            toastMessage: 'Link copied successfully.',
            isErrorAlertMessage: false,
          });
        }
      })
      .catch(() => {
        this.setState({
          showMessage: true,
          toastMessage: this.props.t('errors.somethingWentWrong'),
          isErrorAlertMessage: true,
        });
      });
  }

  render() {
    const {
      tcEvent,
      tcEventStaff,
      locations,
      irregularities,
      rooms,
      testCenterCycle,
      roles,
      eventTasks,
      completedEventTasks,
      capacityTypes,
      manualTimerFlags,
      history,
      tcEventMaterialTypes,
      eventMaterials,
      roomMaterialsCount,
      serverDateTime,
      flagPaperEvent,
      currentRequest,
      submittedIrreg,
      eventStaffCounts,
      devicesCheckCount,
      flagOnlineEvent,
    } = this.props;

    const totalRooms = getTotal(locations);
    const showPending =
      !isEmpty(currentRequest) &&
      (currentRequest.status === REQUEST_UPDATE_STATUS.pending ||
        currentRequest.status === REQUEST_UPDATE_STATUS.inProgress);
    const currentRequestData = get(currentRequest, 'data.eventUpdate', {});
    const currentOrPastEventFlag =
      serverDateTime &&
      !isEmpty(tcEvent) &&
      isCurrentOrPastEventDate(
        serverDateTime,
        tcEvent.rescheduleDate || tcEvent.testingEvent.testDate
      );
    const isPsiEvent =
      !isEmpty(tcEvent) &&
      tcEvent.testingEvent?.adminId &&
      tcEvent.testingEvent.adminId.onlineProvider === ONLINE_PROVIDERS.psi;
    const isNationalEvent = tcEvent.testingEvent?.adminId?.cycleId?.programId?.code === 'actnatl';
    const isSpecialEvent = tcEvent.testingEvent?.adminId?.cycleId?.programId?.code === 'actspecial';

    const testEventEndDate = new Date(tcEvent.testingEvent?.endTestDate);
    const newDate = new Date(testEventEndDate);
    newDate.setDate(testEventEndDate.getDate() + 3); // sets the newDate to 3 days in the future
    newDate.setHours(0, 0, 0, 0);
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const onlineTestingData = (tcEvent.locationEvents || []).reduce(
      (acc, event) => {
        event.locationEventCapacities
          .filter((lec) => lec.capacityType.onlineFlag)
          .forEach((lec) =>
            /byod/i.test(lec.capacityType.type)
              ? (acc.byod = acc.byod + Number(lec.registrationAssignCount || 0))
              : (acc.online = acc.online + Number(lec.registrationAssignCount || 0))
          );
        return acc;
      },
      { byod: 0, online: 0 }
    );

    return !(
      isEmpty(tcEvent) ||
      tcEvent.loading ||
      isEmpty(testCenterCycle) ||
      testCenterCycle.loading ||
      (irregularities && irregularities.loading)
    ) ? (
      <div className="tc-event-container col ">
        <div className="title-container">
          <h4 className="event-title">{this.props.t('tcEventDashboard.title')}</h4>
          <EventDashboardDetails
            date={tcEvent.testingEvent.name}
            name={
              testCenterCycle.testCenterProgram.testCenter &&
              testCenterCycle.testCenterProgram.testCenter.name
            }
          />
        </div>

        {!isSpecialEvent &&
        (isNationalEvent ? currentDate.getTime() < newDate.getTime() : true) &&
        (PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
          PermissionsService.hasEventManage(tcEvent.id)) ? (
          <RequestUpdateContainer
            ref={(instance) => {
              this.child = instance;
            }}
            showPending={showPending}
          />
        ) : null}

        {(PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
          PermissionsService.hasEventManage(tcEvent.id)) &&
          currentOrPastEventFlag && (
            <TcEventCheckout
              tcEvent={tcEvent}
              eventStaffCounts={eventStaffCounts}
              totalSubmittedIrreg={submittedIrreg.length}
              roomsOnlineFlag={checkForOnlineRooms(rooms)}
              nrOfRooms={rooms.length}
              actions={this.props.actions}
              mappedRoomTiming={this.props.mappedRoomTiming}
              isNowManagedFlag={testCenterCycle.testCenterProgram?.testCenter?.nowManagedFlag}
            />
          )}
        <Accordion startPosition={0}>
          {!isSpecialEvent &&
          (PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
            PermissionsService.hasEventManage(tcEvent.id)) &&
          !testCenterCycle.testCenterProgram.testCenter.nowManagedFlag ? (
            <div data-trigger={this.props.t('tcEventDashboard.shippingTitle')}>
              <TcEventShipping
                tcEvent={tcEvent}
                openRequestUpdateTab={this.openRequestUpdateTab}
                showPending={showPending && !isEmpty(currentRequestData.shippingAddress)}
                testCenterCycle={testCenterCycle}
              />
            </div>
          ) : null}

          {PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
          PermissionsService.hasEventManage(tcEvent.id) ||
          PermissionsService.hasAccessTo(
            'testCenterEventChecklistManage',
            'testEvents',
            tcEvent.id
          ) ? (
            <div data-trigger={this.props.t('testCenter.eventDashboard.testEventChecklistTitle')}>
              <TcEventChecklist
                event={tcEvent}
                eventTasks={eventTasks}
                completedEventTasks={completedEventTasks}
              />
            </div>
          ) : null}

          {!testCenterCycle.testCenterProgram.testCenter.nowManagedFlag && (
            <div data-trigger={this.props.t('testCenter.eventDashboard.capacityTitle')}>
              <TcEventCapacity
                locations={locations}
                tcEvent={tcEvent}
                capacityTypes={capacityTypes}
              />
              {(PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
                PermissionsService.hasEventManage(tcEvent.id)) && (
                <>
                  {!testCenterCycle.testCenterProgram.testCenter.nowManagedFlag && (
                    <div>
                      {this.props.t('requestUpdate.capacitySectionMessage')},{' '}
                      <a className="click" onClick={() => this.openRequestUpdateTab('capacity')}>
                        {this.props.t('common.labels.click')}
                      </a>
                    </div>
                  )}

                  {showPending && !isEmpty(currentRequestData.locationEvents) && (
                    <button
                      className="btn btn-small request-update-edit-btn"
                      onClick={() => this.openRequestUpdateTab('capacity')}
                      data-bs-toggle="popover"
                      data-bs-placement="top"
                      data-bs-trigger="hover"
                      data-bs-content={this.props.t('requestUpdate.pending.infoMessage')}>
                      <PendingIcon />
                      {this.props.t('requestUpdate.pending.editBtn')}
                    </button>
                  )}
                </>
              )}
            </div>
          )}

          {PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
          PermissionsService.hasEventManage(tcEvent.id) ||
          PermissionsService.hasAccessTo('testCenterEventRoomManage', 'testEvents', tcEvent.id) ||
          PermissionsService.hasRoomAccess(tcEvent.id) ? (
            <div data-trigger={this.props.t('testCenter.eventDashboard.roomsAndStaff')}>
              <TcEventStaffAndRooms
                event={tcEvent}
                staff={tcEventStaff}
                eventStaffCounts={eventStaffCounts}
                rooms={rooms}
                roles={roles}
                totalRooms={totalRooms}
                manualTimerFlags={manualTimerFlags}
                locations={locations}
                nowManagedFlag={testCenterCycle.testCenterProgram.testCenter.nowManagedFlag}
                testCenterCycle={this.props.testCenterCycle}
              />
            </div>
          ) : null}

          {(PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
            PermissionsService.hasAccessTo(
              'testCenterEventRosterManage',
              'testEvents',
              tcEvent.id
            )) &&
          !tcEvent.specialTestingFlag ? (
            <div data-trigger={this.props.t('testCenter.eventDashboard.rosterTitle')}>
              <TcEventRoster
                tcEvent={tcEvent}
                locations={locations}
                serverDateTime={serverDateTime}
                history={history}
              />
            </div>
          ) : null}

          {(PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
            PermissionsService.hasAccessTo(
              'testCenterEventMaterialManage',
              'testEvents',
              tcEvent.id
            )) &&
          testCenterCycle?.cycle?.logTestbookRequiredFlag ? (
            <div data-trigger={this.props.t('testCenter.eventDashboard.materialsTitle')}>
              <TcEventMaterials
                event={tcEvent}
                tcEventMaterialTypes={tcEventMaterialTypes}
                eventMaterials={eventMaterials}
                roomMaterialsCount={roomMaterialsCount}
                showMaterials={flagPaperEvent}
              />
            </div>
          ) : null}

          <div
            data-trigger={this.props.t('testCenter.eventDashboard.irregularitiesTitle', {
              number: irregularities.length,
            })}>
            <TcEventIrregularities irregularities={irregularities} tcEvent={tcEvent} />
          </div>
          {isPsiEvent &&
            flagOnlineEvent &&
            (PermissionsService.hasTestCenterManage(tcEvent.testCenterCycleId) ||
              PermissionsService.hasEventManage(tcEvent.id)) && (
              <div data-trigger={this.props.t('navigation.onlineTesting')}>
                <section className="event-online-section">
                  <div className="tc-event-online">
                    <div>
                      <span>{this.props.t('tcEventDashboard.onlineTotalAssigned')}</span>
                      <span className="device-count">
                        {onlineTestingData.byod + onlineTestingData.online || 0}
                      </span>
                    </div>
                    <div>
                      <span>{this.props.t('tcEventDashboard.onlineBYODAssigned')}</span>
                      <span className="device-count">{onlineTestingData.byod || 0}</span>
                    </div>
                    <div>
                      <span>{this.props.t('tcEventDashboard.onlineSiteDevicesAssigned')}</span>
                      <span className="device-count">{onlineTestingData.online || 0}</span>
                    </div>
                    <div>
                      <span>{this.props.t('tcEventDashboard.onlineSiteDevicesReady')}</span>
                      <span className="device-count">{devicesCheckCount || 0}</span>
                    </div>
                  </div>

                  <a
                    className="mt-2 btn-link svg-right"
                    href={`https://content.act.org/act_national/r/EyMDzvhTOl~KQ2mYjZokwA/71ulxSF3JKo9bXsbr72pAA`}
                    rel="noopener noreferrer"
                    target="_blank">
                    <LaunchIcon fill="currentColor" height="16" />
                    {this.props.t('tcEventDashboard.onlineDeviceRequirementsLink')}
                  </a>
                </section>

                <AlertMessage
                  show={this.state.showMessage}
                  removeMessage={() => this.removeMessage()}
                  message={this.state.toastMessage}
                  isError={this.state.isErrorAlertMessage}
                />
              </div>
            )}
        </Accordion>
        <button className="btn btn-outline ml-0 w-100 mt-3" onClick={this.props.history.goBack}>
          {this.props.t('common.labels.back')}
        </button>
      </div>
    ) : (
      <Spinner />
    );
  }
}

function mapStateToProps(state) {
  return {
    tasks: state.tcEvent.tasks || [],
    tcEvent: state.tcEvent.currentEvent || {},
    devicesCheckCount: state.tcEvent.devicesCheckCount,
    locations: mapRoomsByLocation(state),
    flagPaperEvent: hasEventPaperCapacity(state),
    irregularities: state.irregularities.eventIrregularities || [],
    submittedIrreg: getSubmittedIrregularities(state),
    rooms: state.tcEvent.rooms || [],
    loadingRooms: state.tcEvent.loadingRooms,
    testCenterCycle: state.tcEvent.testCenterCycle || {},
    tcEventStaff: state.staff.tcEventStaff,
    eventStaffCounts: setEventStaffCounts(state),
    roles: state.statics.roles,
    capacityTypes: state.statics.capacityTypes,
    serverDateTime: state.statics.serverDateTime,
    eventTasks: state.eventChecklist.eventTasks,
    completedEventTasks: getEventTasksCompleted(state),
    manualTimerFlags: getManualTimerFlags(state),
    roomMaterials: mapRoomMaterials(state),
    eventUsedMaterials: calculateEventUsedMaterials(state),
    eventMaterials: mapEventMaterials(state),
    tcEventMaterialTypes: mapEventMaterialTypes(state),
    flagOnlineEvent: hasEventOnlineCapacity(state),
    roomMaterialsCount: state.materialChain.roomMaterialsCount,
    currentRequest: state.requestUpdate.currentRequest,
    mappedRoomTiming: state.statics.mappedRoomTiming,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...tcEventActions,
        ...irregularitiesActions,
        ...staffActions,
        ...eventChecklistActions,
        ...materialChainActions,
        ...staticActions,
        ...requestUpdateActions,
      },
      dispatch
    ),
  };
}

export default withTranslation()(
  withRouterLegacy(connect(mapStateToProps, mapDispatchToProps)(TcEventDashboard))
);

TcEventDashboard.propTypes = {
  tcEvent: PropTypes.shape({
    testCenterCycleId: PropTypes.number,
  }).isRequired,
  tcEventStaff: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  irregularities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rooms: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  locations: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  testCenterCycle: PropTypes.shape({
    name: PropTypes.string,
  }).isRequired,
  actions: PropTypes.shape({
    getTcEvent: PropTypes.func.isRequired,
    getTestCenterCycle: PropTypes.func.isRequired,
    getRooms: PropTypes.func.isRequired,
    getTcEventIrregularities: PropTypes.func.isRequired,
    getRoles: PropTypes.func.isRequired,
    getCapacityTypes: PropTypes.func.isRequired,
  }).isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      eventId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  t: PropTypes.func.isRequired,
};
